import { get } from '../utils/http'
import Env from '@/config/env'

class Home {
  // 增加卡片素材分享量
  async addCardMaterShareNum(params) {
    const res = await get(
      '/api/content/cardMaterial/addCardMaterShareNum',
      params
    )
    return res.data
  }
  //获取首页产品专栏
  async getHomePageProductBar() {
    const res = await get('/api/content/v1/recommend/getHomePageProductBar')
    return res.data
  }

  //获取育儿以及banner专栏数据
  async getAdvertBarList() {
    const res = await get('/api/marketing/advert/getAdvertBarList')
    return res.data
  }

  //导航栏数据
  async getNavigationBarList() {
    const res = await get('/api/marketing/advert/getNavigationBarList')
    return res.data
  }

  //金刚区专栏数据
  async getImagesTagsBarList(type) {
    const params = { type: type }
    const res = await get(
      '/api/content/imagesTags/getImagesTagsBarList',
      params
    )
    return res.data
  }

  //金刚区内页
  async getCourseListByTagsId(params) {
    const res = await get(
      '/api/content/imagesTags/getCourseListByTagsId',
      params
    )
    return res.data
  }

  async getWachatShare(url) {
    const params = {
      objectType: 1,
      type: 5,
      id: 1,
      url: url || Env.mobileUrlFormal
    }
    const res = await get('/api/content/contentShare/getWeChatShare', params)
    return res.data
  }

  async getSigin() {
    const res = await get('/api/content/v1/clockin/pointIfClockInToday')
    return res
  }

  async getBanner(type) {
    const params = { type: type || 2 }
    const res = await get('/api/marketing/banner/get', params)
    // const res = await get('/api/marketing/advert/get', params)
    return res.data
  }

  //广告跳转
  async getAdvert(pageIndex) {
    const params = { pageIndex: pageIndex }
    const res = await get('/api/marketing/advert/getByCondition', params)
    return res.data
  }

  //广告位 不同身份不同广告
  async getBannerByValidate(page) {
    const params = { page: page || 5 }
    const res = await get('/api/marketing/advert/getListByValidate', params)
    return res.data
  }

  // 获取专题
  async getListByCondition() {
    // const params = { type: type || 2 }
    const res = await get('/api/content/v1/columnColumn/getListByCondition')
    // const res = await get('/api/marketing/advert/get', params)
    return res.data
  }

  // 获取精品
  async getCategoryBoutique() {
    const res = await get('/api/content/v1/category/getCategoryBoutique')
    return res.data
  }

  // 获取上新
  async getLatestCourse() {
    const res = await get('/api/content/v1/course/getLatestCourse')
    return res.data
  }

  async getCategories() {
    const res = await get('/api/content/v1/app/getHomeCateList')
    return res.data
  }

  // 获取更新APP地址
  async getUpdaterApp(type) {
    const params = { type: type || 'android' }
    const res = await get('/api/public/v1/updater/current', params)
    return res.data
  }

  // 金刚区
  async getImagesTags(page, limit) {
    let params = {
      status: 1,
      page: page || 1,
      limit: limit || 20,
      createTime: -1
    }
    const res = await get('/api/content/imagesTags/page', params)
    return res.data
  }

  // 每日卡片
  async cardMaterial(page, limit) {
    let params = {
      status: 0,
      page: page || 1,
      limit: limit || 1,
      createTime: -1
    }
    const res = await get('/api/content/cardMaterial/page', params)
    return res.data
  }

  // 根据分类获取对应的列表
  async getListContent(categoryId, page, limit, isRecomend, userId) {
    let params = {}
    if (isRecomend) {
      params = {
        type: 2,
        page: page || 1,
        limit: limit || 20,
        userId
      }
    } else {
      params = {
        categoryId,
        type: 2,
        page: page || 1,
        limit: limit || 20,
        userId
      }
    }
    const res = await get('/api/content/v1/shareMoment/list', params)
    return res.data
  }

  // lqx--已上架,下架审核中,下架审核不通过 并且被屏蔽的id课程查询
  async getShieldCourseByIds() {
    const res = await get('/api/content/v1/course/getShieldCourseByIds')
    return res.data
  }

  // 获取慈善列表 v3版本
  async getCharityV3(data) {
    const res = await get('/api/content/v1/course/common/charity', data)
    return res.data
  }

  // 获取类别列表 公益type=3 直播type=1
  async getCategoryList(data) {
    const res = await get('/api/content/v1/category/getCategoryList', data)
    return res.data
  }

  // 获取公益列表 v3版本
  async getPublicGoodListV3(data) {
    const res = await get('/api/content/v1/course/common/welfare', data)
    return res.data
  }

  // 根据公益类别获取列表
  async getPublicGoodList(data) {
    const res = await get('/api/content/v1/category/getCategoryCharity', data)
    return res.data
  }

  // 获取院长推荐
  async getChiefRecommendListV2(data) {
    const res = await get(
      '/api/content/v1/course/common/firstPageRecommend',
      data
    )
    return res.data
  }

  // 获取公益短视频
  async getCharityShortVideo(data) {
    const res = await get('/api/content/v1/shareMoment/getCharityList', data)
    return res.data
  }

  // 获取直播课堂(第一页)
  async getFirstPageLive(data) {
    const res = await get('/api/content/v1/courseLive/getFirstPageLive', data)
    return res.data
  }

  // 课程上新
  async getLatestCourseSecondV2() {
    const res = await get('/api/content/v1/course/common/latestCourse')
    return res.data
  }

  // 检查是否领取亲友卡
  async checkFriendCard() {
    const res = await get('/api/content/v1/coupons/check')
    return res.data
  }

  // 获取课程榜单列
  async getHotCourseListV2(data) {
    const res = await get('/api/content/v1/course/common/rank', data)
    return res.data
  }

  // 0-18岁短视频
  async getZero2EighteenShortMoment(data) {
    const res = await get(
      '/api/content/v1/shareMoment/getZero2EighteenShortMoment',
      data
    )
    return res.data
  }

  // 获取免费专区列
  async getFreeCourse(data) {
    const res = await get('/api/content/v1/course/getFreeCourse', data)
    return res.data
  }

  // 【首页】- 免费栏目-老师专栏
  async getColumnInfoByColumnIds() {
    const res = await get(
      '/api/content/v1/columnColumn/getColumnInfoByColumnIds'
    )
    return res.data
  }

  //【首页】- 免费栏目-老师专栏-相关推荐
  async getColumnRecommendProduct(data) {
    const res = await get(
      '/api/content/v1/columnCourse/getColumnRecommendProduct',
      data
    )
    return res.data
  }

  //【首页】- 免费栏目-老师简介
  async getColumnTeacherRemark(data) {
    const res = await get(
      '/api/content/v1/columnCourse/getColumnTeacherRemark',
      data
    )
    return res.data
  }

  //【首页】- 免费栏目-老师简介
  async getAllMoment(data) {
    const res = await get('/api/content/v1/shareMoment/getAllMoment', data)
    return res.data
  }

  // 良仕-专家学院课程列表 type: 1高材生精选 2良仕全球大讲堂
  async getCollegeCourseList(data) {
    const res = await get(
      '/api/content/v1/course/expertTeacherCollege/getCollegeCourseList',
      data
    )
    return res.data
  }
  // 获取推客精选产品
  async getSharerChoiceProductList(data) {
    const res = await get(
      '/api/content/v1/sharer/choiceProduct/getSharerChoiceProductList',
      data
    )
    return res.data
  }
  // 良仕-研学：最近一场未开始的研学
  async getStudyTourUpcoming() {
    const res = await get('/api/content/v1/studyTour/getUpcoming')
    return res.data
  }
  // 良仕-研学：分页列表
  async getStudyTourList(data) {
    const res = await get('/api/content/v1/studyTour/getAppList', data)
    return res.data
  }
}

export default new Home()
